import {isPlatformBrowser} from "@angular/common";
import {ClassProvider, FactoryProvider, InjectionToken, PLATFORM_ID, Injectable} from "@angular/core";

export const WINDOW = new InjectionToken("WindowToken");

export abstract class WindowRef {
  get nativeWindow(): Window | Record<string, unknown> {
    throw new Error("Not implemented.");
  }
}

@Injectable()
export class BrowserWindowRef extends WindowRef {
  constructor() {
    super();
  }

  get nativeWindow(): Window | Record<string, unknown> {
    return window;
  }
}

export function windowFactory(
  browserWindowRef: BrowserWindowRef,
  platformId: Record<string, unknown>
): Window | Record<string, unknown> {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }
  return {};
}

const browserWindowProvider: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef,
};

const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [WindowRef, PLATFORM_ID],
};

export const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];
